export default __webpack_public_path__ + "static/media/bti-title-en.0a786ef8.webp";